import { inject } from "@angular/core";
import { HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { LoadingService } from "../../shared/services/loading.service";
import { finalize } from "rxjs";
import { skipLoading } from "../auth-context";

export function loadingInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {

    const loadingService = inject(LoadingService);
    const _skipLoading = req.context.get(skipLoading);

    if (!_skipLoading) {
        loadingService.show();
    }

    return next(req).pipe(
        finalize(() => {
            if (!_skipLoading) {
                loadingService.hide();
            }
        })
    );
}